<div class="conversion-card">

  <div class="card-title">
    {{title}}
  </div>

  <div class="card-summary">
    <div class="card-info">
      <div class="card-kpi">

        <span class="card-value">
          {{ currentValue }}{{ unit }}
        </span>

        <div class="card-change" *ngIf="changeValue !== 0" [ngClass]="{
          'positive': changeValue > 0 && unit === '%' || changeValue < 0 && unit === 'm',
          'negative': changeValue < 0 && unit === '%' || changeValue > 0 && unit === 'm'
          }">

          <img class="card-change-icon" [src]="unit === 'm'
            ? (changeValue > 0
            ? '../../assets/icons/dashboard/arrow_up_red.svg'
            : '../../assets/icons/dashboard/arrow_down_green.svg')
            : (changeValue > 0
            ? '../../assets/icons/dashboard/arrow_up.svg'
            : '../../assets/icons/dashboard/arrow_down.svg')
            " alt="Change">

            <span>
              {{ changeValue > 0 ? '+' : '' }}{{ changeValue }}{{ unit }}
            </span>
        </div>
      </div>

      <div class="card-previous">
        vs. last week {{ previousValue }}{{ unit }}
      </div>
    </div>

    <div class="chart-legend">
      <div class="legend-item">
        <span class="legend-line actual"></span>
        <span>Actual</span>
        <span class="legend-line mission"></span>
        <span>Weekly Pledge</span>
      </div>
    </div>

  </div>

  <div class="chart-container">
    <canvas #missionChart></canvas>
  </div>

  <div class="card-footer">

    <div class="footer-item">
      <div class="footer-label">This week's pledge</div>
      <div class="footer-value">{{weeklyPledge}}{{unit}}</div>
    </div>

    <div class="footer-item">
      <div class="footer-label">Target</div>
      <div class="footer-value">{{target}}{{unit}}</div>
    </div>

    <div class="footer-item">
      <div class="footer-label">Personal Best</div>
      <div class="footer-value">
        <img class="medal" src="../../assets/icons/dashboard/award.svg" />
        {{personalBest}}{{unit}}
      </div>
    </div>

  </div>

</div>